import { c as _c } from "react/compiler-runtime";
import { useDate } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/date-picker-input/hooks";
import { DatePickerInputPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/date-picker-input/types";
import { Datepicker } from "@website/ui/datepicker";
import { FC, useEffect } from "react";
export const DatePickerInput: FC<DatePickerInputPropertiesType> = properties => {
  const $ = _c(12);
  const {
    dateRangeInitial,
    errors,
    onChange
  } = properties;
  const {
    date,
    onChangeDate,
    fromDateTitle,
    toDateTitle,
    calendarLocale
  } = useDate(dateRangeInitial);
  let t0;
  let t1;
  if ($[0] !== calendarLocale || $[1] !== date || $[2] !== onChange) {
    t0 = () => {
      onChange(date, calendarLocale);
    };
    t1 = [date, calendarLocale, onChange];
    $[0] = calendarLocale;
    $[1] = date;
    $[2] = onChange;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  const t2 = Boolean(errors?.dateError);
  const t3 = errors?.dateError;
  let t4;
  if ($[5] !== date || $[6] !== fromDateTitle || $[7] !== onChangeDate || $[8] !== t2 || $[9] !== t3 || $[10] !== toDateTitle) {
    t4 = <Datepicker error={t2} fromTitle={fromDateTitle} fullWidth={true} helperText={t3} mode="start-end" onChange={onChangeDate} toTitle={toDateTitle} value={date} />;
    $[5] = date;
    $[6] = fromDateTitle;
    $[7] = onChangeDate;
    $[8] = t2;
    $[9] = t3;
    $[10] = toDateTitle;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};